import { LoansScreen } from "./LoansScreen";

export const DigitalLoansScreen = () => {
  return <LoansScreen component="Digital" />;
};
